import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';

export const Input = forwardRef(({ className, type = 'text', error, ...props }, ref) => {
  return (
    <input
      type={type}
      ref={ref}
      className={cn(
        'flex h-10 w-full rounded-lg border border-border bg-surface px-3 py-2 text-sm',
        'placeholder:text-text-tertiary',
        'focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'transition-theme',
        error && 'border-error focus:ring-error',
        className
      )}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export const Textarea = forwardRef(({ className, error, rows = 3, ...props }, ref) => {
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(
        'flex min-h-[80px] w-full rounded-lg border border-border bg-surface px-3 py-2 text-sm',
        'placeholder:text-text-tertiary',
        'focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'transition-theme',
        error && 'border-error focus:ring-error',
        className
      )}
      {...props}
    />
  );
});

Textarea.displayName = 'Textarea';

export const Label = ({ children, className, required, ...props }) => {
  return (
    <label
      className={cn(
        'mb-1.5 block text-sm font-medium text-text-primary',
        required && "after:ml-0.5 after:text-error after:content-['*']",
        className
      )}
      {...props}
    >
      {children}
    </label>
  );
};

export const Select = forwardRef(({ children, className, error, ...props }, ref) => {
  return (
    <select
      ref={ref}
      className={cn(
        'flex h-10 w-full rounded-lg border border-border bg-surface px-3 py-2 text-sm',
        'focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'transition-theme',
        error && 'border-error focus:ring-error',
        className
      )}
      {...props}
    >
      {children}
    </select>
  );
});

Select.displayName = 'Select';
